import { createAction } from 'redux-actions'
import Api from '../Api'

import { SAVE_RIDER } from './rider'

export const ADD_RIDER_CONTACT = createAction('ADD_RIDER_CONTACT')
export const REMOVE_RIDER_CONTACT = createAction('REMOVE_RIDER_CONTACT')
export const CREATE_RIDER_CONTACT = createAction('CREATE_RIDER_CONTACT')
export const EDIT_RIDER_CONTACT = createAction('EDIT_RIDER_CONTACT')
export const DELETE_RIDER_CONTACT = createAction('DELETE_RIDER_CONTACT')

export const addRiderContact = (contact) => {
  return (dispatch) => dispatch(ADD_RIDER_CONTACT({contact}))
}

export const removeRiderContact = (index) => {
  return (dispatch) => dispatch(REMOVE_RIDER_CONTACT({index}))
}

export const createRiderContact = (riderId, contact) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(CREATE_RIDER_CONTACT(Api.createRiderContact(riderId, contact)))
  }
}

export const editRiderContact = (contact) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(EDIT_RIDER_CONTACT(Api.editRiderContact(contact)))
  }
}

export const deleteRiderContact = (contact) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(EDIT_RIDER_CONTACT(Api.deleteRiderContact(contact)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/rider-contact.js